let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6n8TN")).then(() => parcelRequire('iqugp'));